export const BaseURL = process.env.REACT_APP_URL;

export const Url = {
  participants_privacy: "participants/privacy_policy/{0}/{1}/file.html",
  participants_terms_of_use: "participants/terms_of_use/{0}/{1}/file.html",
  participants_terms_of_use_languages: "participants/terms_of_use/{0}/config.json",
  participants_privacy_languages: "participants/privacy_policy/{0}/config.json",
  clinical_team_privacy: "clinical_team/privacy_policy/{0}/{1}/file.html",
  clinical_team_terms_of_use: "clinical_team/terms_of_use/{0}/{1}/file.html",
  clinical_team_terms_of_use_languages: "clinical_team/terms_of_use/{0}/config.json",
  clinical_team_privacy_languages: "clinical_team/privacy_policy/{0}/config.json",
  support: "support/{0}/file.html",
  support_languages: "support/config.json",
  translations:'config/languages.json'
};
